// extracted by mini-css-extract-plugin
module.exports = {"home":"About_home__1MIKs","infoBox":"About_infoBox__1WjSk","mainBox":"About_mainBox__3B8mH","leftBox":"About_leftBox__1TH6P"};